import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, Menu } from 'antd';
import { Spin } from 'antd';
import { logout } from '../../redux/actions/login';
import { LoadingOutlined } from '@ant-design/icons';
import profileIconCPAY from '../../img/default-svg/profileCircle.svg';
import profileIconNFG from '../../img/default-svg/profileCircleNFG.svg';
import profileIconFinvaro from '../../img/default-svg/profileCircleFinvaro.svg';
import profileIconInex from '../../img/inex/profileCircle.svg';
import profileIconInsta from '../../img/instaXchange/profileCircle.svg';
import profileIconCoinera from '../../img/coinera/profileCircle.svg';
import useWindowSize from '../../utils/resizeHook';
import { identity } from '../../utils/getIdentity';
import './HeaderUser.scss';

const profileIcon = {
  cpay: profileIconCPAY,
  nfg: profileIconNFG,
  finvaro: profileIconFinvaro,
  clarnium: profileIconCPAY,
  inex: profileIconInex,
  insta: profileIconInsta,
  coinera: profileIconCoinera
};

const antIcon = <LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />;

const HeaderUser = ({ userData, logout }) => {
  const { t } = useTranslation();
  const { isLg } = useWindowSize();
  return (
    <>
      {userData.name && userData.name.length > 0 ? (
        <Dropdown
          overlay={
            <Menu className={`header-user-${identity}`}>
              {userData.roles.includes('admin') && (
                <Menu.Item className={`header-item-${identity}`}>
                  <Link className={`header-link-${identity}`} to="/admin">{t('profile.switch')}</Link>
                </Menu.Item>
              )}
              <Menu.Item className={`header-item-${identity}`}>
                <Link className={`header-link-${identity}`} to="/profile">{t('profile.profile')}</Link>
              </Menu.Item>
              <Menu.Item className={`header-item-${identity}`}>
                <div onClick={logout}>{t('logOut')}</div>
              </Menu.Item>
            </Menu>
          }
          placement="topCenter"
          arrow
        >
          <div className={`header__user-name header__user-name-${identity}`}>
            <img src={profileIcon[identity]} alt="" />
            {isLg && <div>{`${userData.name} ${userData.surname || ''}`}</div>}
          </div>
        </Dropdown>
      ) : (
        <Spin indicator={antIcon} />
      )}
    </>
  );
};

const mapStateToProps = state => ({
  userData: state.user.data,
});

const mapDispatchToProps = dispatch => ({
  logout: logout(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderUser);
